module.exports = __webpack_public_path__ + "static/gmail-f74cd93749325477721f8400ce79ee3a.svg";